export const BILLING_TARIFF_ALIAS = {
  FREE: 'free',
  PER_JOB: 'per_job',
  PREMIUM: 'premium',
  ENTERPRISE: 'enterprise',
}
